import {
  SecondaryBlockType,
  processLayoutOptions,
  LayoutOptions,
  Shared,
} from "@kameleon-core/lib";
import { InferProps } from "prop-types";

export const layoutOptions = {
  showIconBackground: LayoutOptions.Boolean,
};

const layoutProps = processLayoutOptions(layoutOptions);
export type LayoutProps = InferProps<typeof layoutProps>;

type Point = {
  icon: string;
  text: string;
};

export type PointsType = {
  /** Place prop documentation here */
  points?: Point[];
} & SecondaryBlockType<LayoutProps> &
  Shared.Props.TripleButtonProps;
